// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"455":"chunk.canvas-confetti","621":"chunk.select2"}[chunkId] + ".js";
};